import { render } from "./ShipyardDetails.vue?vue&type=template&id=bc63a9de&scoped=true"
import script from "./ShipyardDetails.vue?vue&type=script&lang=ts"
export * from "./ShipyardDetails.vue?vue&type=script&lang=ts"

import "./ShipyardDetails.vue?vue&type=style&index=0&id=bc63a9de&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bc63a9de"

export default script